// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24eWY","content":"styles_content__3sQW8","row":"styles_row__8Bxoe","footer":"styles_footer__3RS5G","phraseLength":"styles_phraseLength__2t1MN"};